<template>
    <div>
        <ei-header :header2-show="true" :header2-lit="true"></ei-header>
        <ei-article-detail :title="title" :time="time" :content="content"></ei-article-detail>
        <ei-footer></ei-footer>
    </div>
</template>

<script>
    import {queryArticleAction} from "@/api/reception/article-api";
    import {isFailure} from "@/eiuov-utils/axios/response";

    export default {
        name: "PageArticleDetail",
        data(){
            return{
	            title:'',
	            time:'',
	            content:''
            }
        },
        created() {
	        this.rowGuid=this.$cookies.get("article_guid")
	        queryArticleAction({rowGuid:this.rowGuid}).then((res)=>{
		        if (isFailure(res)) return
		        this.title=res.data.article.title
		        this.time=res.data.article.operateTime
		        this.content=res.data.article.content
	        })
        }
    }
</script>

<style scoped>
    .ei-article-detail{
        margin-top: 120px;
        margin-bottom: 50px;
    }
</style>
